import Mutations from '../../odata/mutations';

export default { ...new Mutations('saleLead'), ...new Mutations('saleLeads') };
